import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Form from '../../../../util/Form'
import { present, email, length, matchesField } from '../../../../util/Form/validators'

import ResellerMembersStore from '../../../../../stores/resellers'
import ResellerTeamsStore from '../../../../../stores/reseller_teams'

import { Link } from 'react-router'
import { up } from '../../../../../utils/url'

@inject('auth')
@observer
export default class AddResellerMember extends Component {
  resellers = new ResellerMembersStore()
  resellerTeams = new ResellerTeamsStore()

  componentDidMount() {
    if (this.props.params.reseller_team_id) this.resellerTeams.load(this.props.params.reseller_team_id)
  }

  handleData = data => {
    return this.resellers.create(data).then(() => this.props.router.push(up(1)(this.props.location)))
  }

  render() {
    if (this.props.params.reseller_team_id && !this.resellerTeams.loaded) return <div className="loading">Loading...</div>

    const validations = [
      { field: 'name', validate: present, message: 'All resellers must have a name' },
      { field: 'email', validate: [present, email], message: 'New reseller must have a valid email' },
      { field: 'password', validate: [present, length(8)], message: 'Reseller must have a password of at least 8 characters' },
      { field: 'confirm_password', validate: matchesField('password'), message: 'Confirmation must match password' }
    ]

    const { reseller_team_id = this.props.auth.user.reseller_team.id } = this.props.params

    const forTeam = this.resellerTeams.findById(reseller_team_id)

    return (
      <div className="container padded teams">
        <Form ref={el => this.form = el && el.form} className="full" validations={validations} onData={this.handleData}>
          <div className="panel full padded">
            {this.props.params.reseller_team_id ? (
              <h2 className="title"><Link to={up(2)}>Reseller Teams</Link> / <Link to={up(1)}>{forTeam.name}</Link> / Add Member</h2>
            ) : (
              <h2 className="title">Add New Reseller Member</h2>
            )}

            <input type="hidden" value={reseller_team_id} name="reseller_team_id" />

            <div className="form-section">
              <label htmlFor="name">Reseller Name</label>
              <input name="name" id="name" placeholder="Enter a Name" />
            </div>

            <div className="form-section">
              <label htmlFor="email">Reseller Email</label>
              <input name="email" id="email" placeholder="Enter an Email" />
            </div>

            <div className="form-section">
              <label htmlFor="password">Password</label>
              <input type="password" name="password" id="password" placeholder="Enter a Password" />
            </div>

            <div className="form-section">
              <label htmlFor="confirm_password">Password Confirmation</label>
              <input type="password" name="confirm_password" id="confirm_password" />
            </div>
            <button type="submit" className="big shadowed">Add User</button>
          </div>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Admin/Resellers/Teams/AddMember.js